import React, { Component, createRef, forwardRef, createContext } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import { GlobalHandler } from '../GlobalHandlers';
import classNames from 'classnames';

export let List = ({ children }) => (
    <table className="gx-table">{children}</table>
);

let ListContext = createContext('td');

export let ListHead = forwardRef(({ className, children }, ref) => (
    <ListContext.Provider value="th">
        <thead ref={ref} className={classNames(['gx-table__head', className])}>
            {children}
        </thead>
    </ListContext.Provider>
));

export class StickyListHead extends Component {
    refElement = createRef();

    state = { sticky: false };

    stickyClassName = 'list_head--sticky';

    get left() {
        return this.state.left || 0;
    }

    onScroll = () => {
        if (!this.refElement.current) {
            return;
        }

        let { top, left } = this.refElement.current.getBoundingClientRect();

        if (top < 0) {
            this.setState({ left, sticky: true });
        } else {
            this.setState({ sticky: false });
        }
    };

    setCloneWidth = el => {
        if (!el) {
            return;
        }

        let children = this.refElement.current.querySelectorAll('th');
        let cloneChildren = el.querySelectorAll('th');

        [].forEach.call(children, (node, i) => {
            cloneChildren[i].style.width = `${node.offsetWidth}px`;
        });
    };

    render() {
        return (
            <GlobalHandler
                event="scroll"
                on="document"
                callback={evt => {
                    this.onScroll(evt);
                }}
                options={{ passive: true }}
            >
                <ListHead
                    {...this.props}
                    ref={this.refElement}
                    className={classNames([this.props.className])}
                />
                {this.state.sticky &&
                    createPortal(
                        <table>
                            <ListHead
                                {...this.props}
                                ref={this.setCloneWidth}
                                style={{ left: this.left }}
                                className={classNames([
                                    this.stickyClassName,
                                    this.props.className,
                                ])}
                            />
                        </table>,
                        document.body
                    )}
            </GlobalHandler>
        );
    }
}
export class ListBody extends Component {
    static childContextTypes = {
        FieldNodeType: PropTypes.string,
    };

    getChildContext() {
        return {
            FieldNodeType: 'td',
        };
    }

    render() {
        let { className, children } = this.props;
        return (
            <tbody className={classNames(['gx-table__body', className])}>
                {children}
            </tbody>
        );
    }
}

export let ListItem = React.forwardRef(
    ({ className, onClick, children }, ref) => (
        <tr
            ref={ref}
            onClick={onClick ? e => onClick(e) : null}
            className={classNames(['gx-table__row', className])}
        >
            {children}
        </tr>
    )
);

export let ListField = ({ className, children, interactive }) => (
    <ListContext.Consumer>
        {FieldNodeType => (
            <FieldNodeType
                className={classNames(['gx-table__field', className])}
            >
                <div
                    className={`gx-table__cell ${
                        interactive ? 'gx-table__cell--interactive' : ''
                    }`}
                >
                    {children}
                </div>
            </FieldNodeType>
        )}
    </ListContext.Consumer>
);

ListField.contextTypes = {
    FieldNodeType: PropTypes.string,
};
